document.addEventListener('DOMContentLoaded',function(){
 if(!document.body.classList.contains('template-product'))return;
 var lang=(document.documentElement.lang||'fr').slice(0,2).toLowerCase();
 var copies={
  fr:{secure:'Paiement 100% sécurisé',reviews:'AVIS',option:'Option'},
  en:{secure:'100% secure payment',reviews:'REVIEWS',option:'Option'},
  es:{secure:'Pago 100 % seguro',reviews:'RESEÑAS',option:'Opción'}
 };
 var copy=copies[lang]||copies.fr;
 function productStrings(){try{return typeof theme!=='undefined'&&theme.strings&&theme.strings.product?theme.strings.product:{}}catch(e){return{}}}
 var section=document.querySelector('.section-product-single'),grid=section&&section.querySelector('.grid-content'),form=document.querySelector('#wrapper-form1');if(!section||!grid||!form)return;
 var direct=Array.from(grid.children).filter(function(el){return el.classList&&el.classList.contains('grid-item')});
 var gallery=direct.find(function(el){return el.querySelector('.cont-photos,.slider-product')});var right=direct.find(function(el){return el.querySelector('#wrapper-form1')});
 if(gallery)gallery.classList.add('bdf-product-gallery-panel');if(right)right.classList.add('bdf-product-right-panel');
 var slider=section.querySelector('.slider-product'),thumbs=section.querySelector('.slider-product-thumbnails'),sliderContainer=section.querySelector('.slider-container');
 if(sliderContainer){sliderContainer.classList.add('bdf-thumbs-bottom');if(slider&&thumbs){sliderContainer.appendChild(slider);sliderContainer.appendChild(thumbs)}}
 var tabs=section.querySelector('.my-tab');if(right&&tabs){var holder=tabs.closest('.grid-item.small--one-whole.full-width');right.appendChild(tabs);if(holder&&holder!==right&&holder.children.length===0)holder.remove()}
 var productForm=form.querySelector('.product-form form');
 if(productForm){
  productForm.querySelectorAll('.bdf-variant-row').forEach(function(n){n.remove()});
  var row=document.createElement('div');row.className='bdf-variant-row';
  var sectionId=section.getAttribute('data-section-id');
  var productJson=document.getElementById('ProductJson-'+sectionId);
  var productData=null;
  var variantField=productForm.querySelector('select[name="id"]');
  if(productJson){try{productData=JSON.parse(productJson.textContent||'{}')}catch(e){productData=null}}
  var currentVariant=null;
  if(productData&&Array.isArray(productData.variants)&&variantField){
   currentVariant=productData.variants.find(function(item){return String(item.id)===String(variantField.value)})||null;
  }
  function selectedVariant(){
   if(!productData||!Array.isArray(productData.variants)||!variantField)return null;
   return productData.variants.find(function(item){return String(item.id)===String(variantField.value)})||null;
  }
  function syncPrimaryCtaText(){
   var nodes=Array.from(productForm.querySelectorAll('[data-bdf-add-to-cart-text]'));if(!nodes.length)return;
   var strings=productStrings(),fallback=(nodes[0].textContent||'').trim(),variant=selectedVariant(),label=fallback;
   if(!variant)label=strings.unavailable||fallback;
   else if(variant.available===false)label=strings.soldOut||fallback;
   else label=strings.addToCart||fallback;
   nodes.forEach(function(node){node.textContent=label});
  }
  function scheduleCtaSync(){window.setTimeout(syncPrimaryCtaText,0)}
  productForm.addEventListener('change',scheduleCtaSync);
  var swatches=Array.from(productForm.querySelectorAll('.swatch')).filter(function(s){return s.querySelector('input[type="radio"]')});
  var bdfVariantControls=[];
  function findSourceRadio(control,value){
   return Array.from(control.swatch.querySelectorAll('input[type="radio"]')).find(function(input){return input.value===value});
  }
  function isVariantValueAvailable(optionIndex,value){
   if(!productData||!Array.isArray(productData.variants))return null;
   return productData.variants.some(function(variant){
    if(!variant.available||!Array.isArray(variant.options))return false;
    if(String(variant.options[optionIndex])!==String(value))return false;
    if(optionIndex===0)return true;
    for(var i=0;i<optionIndex;i++){
     var previous=bdfVariantControls[i];
     if(previous&&String(variant.options[i])!==String(previous.select.value))return false;
    }
    return true;
   });
  }
  function refreshVariantAvailability(){
   bdfVariantControls.forEach(function(control,optionIndex){
    Array.from(control.select.options).forEach(function(opt){
     var available=isVariantValueAvailable(optionIndex,opt.value);
     if(available===null)return;
     opt.disabled=!available;
     var radio=findSourceRadio(control,opt.value);
     if(radio)radio.disabled=!available;
    });
   });
   bdfVariantControls.forEach(function(control){
    var selectedOption=control.select.options[control.select.selectedIndex];
    if(selectedOption&&!selectedOption.disabled){
     control.select.setAttribute('data-bdf-last-valid-value',control.select.value);
     return;
    }
    var firstAvailable=Array.from(control.select.options).find(function(opt){return !opt.disabled});
    if(!firstAvailable)return;
    control.select.value=firstAvailable.value;
    control.select.setAttribute('data-bdf-last-valid-value',firstAvailable.value);
    var radio=findSourceRadio(control,firstAvailable.value);
    if(radio&&!radio.disabled){
     radio.checked=true;
     radio.dispatchEvent(new Event('change',{bubbles:true}));
    }
   });
  }
  swatches.forEach(function(swatch,optionIndex){
   var label=((swatch.querySelector('.swatch-header')||{}).textContent||copy.option).trim();
   var wrap=document.createElement('div');wrap.className='bdf-variant-select';
   var lab=document.createElement('div');lab.className='bdf-variant-label';lab.textContent=label;
   var select=document.createElement('select');select.className='bdf-variant-native';select.setAttribute('aria-label',label);
   var selectedValue=currentVariant&&Array.isArray(currentVariant.options)?currentVariant.options[optionIndex]:null;
   Array.from(swatch.querySelectorAll('.swatch-element input[type="radio"]')).forEach(function(radio){
    var opt=document.createElement('option');opt.value=radio.value;opt.textContent=radio.value;opt.disabled=radio.disabled;
    if(selectedValue!==null&&radio.value===selectedValue)opt.selected=true;
    select.appendChild(opt);
   });
   if(selectedValue!==null){
    var selectedRadio=Array.from(swatch.querySelectorAll('input[type="radio"]')).find(function(radio){return radio.value===selectedValue});
    if(selectedRadio)selectedRadio.checked=true;
   }
   var control={swatch:swatch,select:select,optionIndex:optionIndex};
   bdfVariantControls.push(control);
   select.setAttribute('data-bdf-last-valid-value',select.value);
   select.addEventListener('change',function(){
    var selectedOption=select.options[select.selectedIndex];
    if(!selectedOption||selectedOption.disabled){
     var previousValue=select.getAttribute('data-bdf-last-valid-value');
     if(previousValue!==null)select.value=previousValue;
     refreshVariantAvailability();
     return;
    }
    var radio=findSourceRadio(control,select.value);
    if(!radio||radio.disabled){
     var lastValue=select.getAttribute('data-bdf-last-valid-value');
     if(lastValue!==null)select.value=lastValue;
     refreshVariantAvailability();
     return;
    }
    select.setAttribute('data-bdf-last-valid-value',select.value);
    radio.checked=true;
    refreshVariantAvailability();
    radio.dispatchEvent(new Event('change',{bubbles:true}));
   });
   wrap.appendChild(lab);wrap.appendChild(select);row.appendChild(wrap);swatch.classList.add('bdf-original-swatch');
  });
  refreshVariantAvailability();
  syncPrimaryCtaText();
  var qty=productForm.querySelector('.quantity-wrapper');if(qty){qty.classList.add('bdf-qty-control');row.appendChild(qty)}
  var controlCount=row.children.length;row.classList.add('bdf-controls-'+Math.min(Math.max(controlCount,1),4));
  if(controlCount){var anchor=productForm.querySelector('.cont-selector');if(anchor)anchor.insertAdjacentElement('afterend',row);else productForm.insertBefore(row,productForm.firstChild)}
 }
 var old=form.querySelector('.bdf-secure-line');if(old)old.remove();var buttons=form.querySelector('.full-width');if(buttons){var secure=document.createElement('div');secure.className='bdf-secure-line';secure.innerHTML='<span>'+copy.secure+'</span>';buttons.insertAdjacentElement('afterend',secure)}
 var oldTrust=document.querySelector('.bdf-product-trust');if(oldTrust)oldTrust.style.display='none';

 function normalizeLegacyProductCopy(){
  var strings=productStrings();
  form.querySelectorAll('.visually-hidden').forEach(function(node){
   var text=(node.textContent||'').trim();
   if(text==='Prix régulier'&&strings.regularPrice&&text!==String(strings.regularPrice).trim())node.textContent=strings.regularPrice;
   else if(text==='Prix réduit'&&strings.salePrice&&text!==String(strings.salePrice).trim())node.textContent=strings.salePrice;
  });
  form.querySelectorAll('.save-text').forEach(function(node){
   var text=(node.textContent||'').trim();
   if((text==='Economisez'||text==='Économisez')&&strings.save&&text!==String(strings.save).trim())node.textContent=strings.save;
  });
 }
 function normalizeMainProductPrice(){
  var priceNode=form.querySelector('[id^="productPrice-"]');
  if(priceNode){
   var walker=document.createTreeWalker(priceNode,NodeFilter.SHOW_TEXT);
   var node;
   while((node=walker.nextNode())){
    var current=node.nodeValue||'';
    var next=current.replace(/([0-9]+)[,.]00(?=\s*€)/g,'$1');
    if(next!==current)node.nodeValue=next;
   }
  }
  normalizeLegacyProductCopy();
 }
 normalizeMainProductPrice();
 var priceNode=form.querySelector('[id^="productPrice-"]');
 if(priceNode){
  var priceObserver=new MutationObserver(function(){normalizeMainProductPrice();});
  priceObserver.observe(priceNode,{childList:true,subtree:true,characterData:true});
 }
 var comparePriceNode=form.querySelector('[id^="comparePrice-"]');
 if(comparePriceNode){
  var comparePriceObserver=new MutationObserver(function(){normalizeLegacyProductCopy();});
  comparePriceObserver.observe(comparePriceNode,{childList:true,subtree:true,characterData:true});
 }

 if(right){
  var oldInjected=right.querySelector('.bdf-product-title-explicit:not(h1)');if(oldInjected)oldInjected.remove();
  var title=right.querySelector('h1.title-primary');
  if(title)title.classList.add('bdf-product-title-explicit');
  if(!title)return;
  function buildReviewLine(){
   var existing=right.querySelector('.bdf-review-line-fixed');if(existing)return existing;
   var loox=right.querySelector('.loox-rating[data-raters]');
   var raters=loox?parseInt(loox.getAttribute('data-raters')||'0',10):0;
   var nodes=Array.from(right.querySelectorAll('span,div,a,strong'));
   var countNode=nodes.find(function(el){return /^\s*\d+\s+(AVIS|REVIEWS|RESEÑAS)\s*$/i.test(el.textContent||'')||/^\s*\(\d+\)\s*$/.test(el.textContent||'')});
   if(countNode){var m=(countNode.textContent||'').match(/\d+/);if(m)raters=parseInt(m[0],10)}
   if(!loox&&!countNode)return null;
   if(countNode)countNode.style.display='none';
   var line=document.createElement('div');line.className='bdf-review-line-fixed';
   var stars=document.createElement('span');stars.className='bdf-review-stars-fixed';stars.setAttribute('aria-hidden','true');stars.textContent='★★★★★';
   var link=document.createElement('a');link.className='bdf-review-count-link';link.href='#looxReviews';link.textContent=raters>0?'('+raters+')':'0 '+copy.reviews;
   line.appendChild(stars);line.appendChild(link);
   (title.closest('.block-title')||title).insertAdjacentElement('afterend',line);
   return line;
  }
  function positionOnlyHeader(){
   var price=form.querySelector('[id^="productPrice-"] .money,[id^="productPrice-"],.product-cont-header2 .money,.product-cont-header2 .price');if(!price)return;
   var targetX=price.getBoundingClientRect().left;
   var elements=[title];var line=buildReviewLine();if(line)elements.push(line);
   elements.forEach(function(el){el.style.transform='none';var x=el.getBoundingClientRect().left;el.style.transform='translateX('+(targetX-x)+'px)'});
   title.style.marginBottom=line?'18px':'28px';if(line){line.style.marginTop='0px';line.style.marginBottom='34px'}
  }
  requestAnimationFrame(function(){requestAnimationFrame(positionOnlyHeader)});setTimeout(positionOnlyHeader,500);window.addEventListener('resize',function(){requestAnimationFrame(positionOnlyHeader)});
 }
});